export default __webpack_public_path__ + "static/media/Screenshot_18.e80d1619.png";